<template>
    <div class="flex flex-col text-gray-100 w-[25%] pl-3 text-sm">
        <p class="text-turquoise text-lg mb-1 font-medium">LEGEND</p>
            
        <p class="inline-flex items-baseline"> 
            <img src="./../assets/pfennigparadeLogo.svg" class="self-center w-4 h-4 rounded-full mx-1" /> 
            <span> Stiftung Pfennigparade </span>
        </p>


        <div class="inline-flex items-baseline"> 
            <img src="./../assets/ubahnsLogo.svg" class="self-center w-4 h-4 mx-1" /> 
            <span> U-Bahn Station</span>
        </div>

        <div class="inline-flex items-baseline"> 
            <img src="./../assets/restaurantsLogo.svg" class="self-center w-4 h-4 rounded-full mx-1" /> 
            <span> Restaurant</span>
        </div>

        <div class="inline-flex items-baseline"> 
            <img src="./../assets/destinationsLogo.svg" class="self-center w-4 h-4 rounded-full mx-1" /> 
            <span> Other destination</span>
        </div>
        
        <p class="mt-5">Streets added...</p>
        <div class=" flex ">
            <img src="./../assets/line1.svg" class="self-center w-5 h-5 rounded-full mx-1" /> 
            <span> up to one month ago</span>
        </div>
        <div class=" flex ">
            <img src="./../assets/line2.svg" class="self-center w-5 h-5 rounded-full mx-1" /> 
            <span> one to six months ago</span>
        </div>
        <div class=" flex ">
            <img src="./../assets/line3.svg" class="self-center w-5 h-5 rounded-full mx-1" /> 
            <span> more than six months ago</span>
        </div>

        <!-- <p class="mt-5 text-turquoise">HOW TO USE</p>
        <p class="text-justify">Choose a destination to see the shortest accessible route from Stifung Pfennigparade.
        Move over a destination in the map to obtain more information.</p> -->

        
        <p class="mt-5 text-turquoise text-lg mb-1 font-medium">ABOUT</p>
        <p class="text-left">This website aims to show wheelchair-friendly routes with different destinations in Munich.
        The routes focused on the neighbourhood of the rehabiliation center Stiftung Pfennigparade.</p>
        <p class="text-left mt-3">Note: The information about toilets refers to the availability of accessible toilets only
            (source: wheelmap.org). The option of data contribution by users is currently in progress.</p>
        
        <!-- <p class="mt-5 text-turquoise text-lg mb-1 font-medium">CREATED BY</p> -->
        <p class="mt-5">Created by: Yi Zhen Chew & Ulrike Holfeld</p>
        
    </div>
</template>

<script>
    export default {
        name: "aboutMap",
        // setup() {
        //     return { ubahn: require('./../assets/ubahnsLogo.svg') }
        // }
    }
</script>